//import isEmpty from "../validation/is-empty";

import { GET_PROPERTY, GET_SINGLE_PROPERTY } from "../actions/types";

const initialState = {
  properties: [],
  property: {}
};

export default function(state = initialState, action) {
  switch (action.type) {
    case GET_PROPERTY:
      return {
        ...state,
        properties: action.payload,
        property: {}
      };
    case GET_SINGLE_PROPERTY:
      return {
        ...state,
        property: action.payload
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/propertyReducer.js